<template>
    <div class="event-brand">
        <img v-if="branding.logo && !failed" :src="branding.logo" :alt="name" @error="failed = true">
        <span v-else>{{ name }}</span>
    </div>
</template>
<script>
import { activeEvent, normalizeBranding } from '@/utils/event-branding'
export default {
    data: () => ({ failed: false }),
    computed: {
        event() { return activeEvent(this.$store.state.game); },
        branding() { return normalizeBranding(this.event?.branding); },
        name() { return this.event?.name || 'La Vuelta'; },
    },
    watch: { 'branding.logo'() { this.failed = false; } },
}
</script>
<style>
.event-brand { display:flex; align-items:center; justify-content:flex-end; max-width:45%; font-size:.65rem; font-weight:700; letter-spacing:.12em; text-transform:uppercase; }
.event-brand img { max-width:160px; max-height:42px; object-fit:contain; background:white; border-radius:6px; padding:5px; }
</style>
